module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.68a29e0.ttf";